var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgRank4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 87C67.5244 87 87 67.5244 87 43.5C87 19.4756 67.5244 0 43.5 0C19.4756 0 0 19.4756 0 43.5C0 67.5244 19.4756 87 43.5 87Z",
    fill: "url(#paint0_radial_2646_11890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4996 81.3386C64.3966 81.3386 81.3369 64.3983 81.3369 43.5013C81.3369 22.6044 64.3966 5.66406 43.4996 5.66406C22.6027 5.66406 5.66235 22.6044 5.66235 43.5013C5.66235 64.3983 22.6027 81.3386 43.4996 81.3386Z",
    fill: "white",
    stroke: "url(#paint1_radial_2646_11890)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5249 48.7579L25.4751 54.5206H62.6486L63.7061 47.5778C64.0586 45.2559 64.0509 42.8881 63.6831 40.5661L62.6409 34.0526L52.5257 43.8766L44.058 29.9375L34.5252 44.3594L25.4751 34.7729L24.5862 39.7692C24.0498 42.7425 24.0268 45.7847 24.5249 48.7579Z",
    fill: "url(#paint2_linear_2646_11890)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0588 61.4959H28.0733C26.6403 61.4959 25.4832 60.3388 25.4832 58.9058V55.8789H62.6566V58.9058C62.6489 60.3311 61.4918 61.4959 60.0588 61.4959Z",
    fill: "url(#paint3_linear_2646_11890)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6566 54.5234H25.4832V55.8798H62.6566V54.5234Z",
    fill: "url(#paint4_linear_2646_11890)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4835 38.1676C27.7562 38.1676 29.5985 36.3252 29.5985 34.0526C29.5985 31.7799 27.7562 29.9375 25.4835 29.9375C23.2108 29.9375 21.3684 31.7799 21.3684 34.0526C21.3684 36.3252 23.2108 38.1676 25.4835 38.1676Z",
    fill: "url(#paint5_radial_2646_11890)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7991 35.7067C46.0718 35.7067 47.9142 33.8643 47.9142 31.5916C47.9142 29.3189 46.0718 27.4766 43.7991 27.4766C41.5265 27.4766 39.6841 29.3189 39.6841 31.5916C39.6841 33.8643 41.5265 35.7067 43.7991 35.7067Z",
    fill: "#B4D5EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1148 38.7575C64.3875 38.7575 66.2299 36.9151 66.2299 34.6424C66.2299 32.3697 64.3875 30.5273 62.1148 30.5273C59.8421 30.5273 57.9998 32.3697 57.9998 34.6424C57.9998 36.9151 59.8421 38.7575 62.1148 38.7575Z",
    fill: "url(#paint6_radial_2646_11890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2646_11890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9767 42.2179) scale(59.115)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#9FC1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#A5FFED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2646_11890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4984 43.5001) scale(39.0036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#80F1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2646_11890",
    x1: 44,
    y1: 30,
    x2: 44.0653,
    y2: 58.0209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2CEE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B8E2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#9ABAF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2646_11890",
    x1: 38.158,
    y1: 50.3699,
    x2: 38.158,
    y2: 62.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#C8FDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#9BC0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2646_11890",
    x1: 56.4738,
    y1: 54.9467,
    x2: 29.0001,
    y2: 54.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55789C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430556,
    stopColor: "#B8E0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#496A94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2646_11890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1842 34.3435) rotate(-45) scale(4.31707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#9DD1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D8FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2646_11890",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8155 34.9334) rotate(-45) scale(4.31707)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "#9DD1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D8FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRank4);
export default __webpack_public_path__ + "static/media/img_rank4.5382353b2bc99c1bcd4951c37555fbb9.svg";
export { ForwardRef as ReactComponent };